<template>
    <CenterBox
        :pageID="1029"
        @permissionData="(data) => {
            this.permissionDetails = data
        }"
    >
        <h1 style="text-align: center">{{ $t('sys_auto_logout') }}</h1>
        <form class="center-box-form d-flex flex-column justify-content-center align-items-center" @submit.prevent="submitForm">
            <div class="mb-3">
                <p class="error-text" v-if="error">{{error}}</p>
                <label for="licenceInput" class="form-label">{{ $t('sys_auto_logout') }}</label>
                <input type="number" class="form-control" id="licenceInput"
                       aria-describedby="licenceHelp" placeholder='... Second'
                       v-model="autoTime"
                >
                <div id="licenceHelp" class="form-text"></div>
            </div>
            <button type="submit" class="btn btn-primary" style="width: 50%">{{ $t("common_submit") }}</button>
        </form>
        <div v-if="error_details">
            <p v-for="(value, key) in error_details" class="error-text">
                {{ key }}: {{value[0]}}
            </p>
        </div>
    </CenterBox>
</template>

<script>
import CenterBox from "@/components/routerViewLocation/CenterBox";

export default {
    name: "SystemAutoLogoutView",
    components: {
        CenterBox
    },
    data(){
        return {
            permissionDetails: {},
            error: '',
            autoTime: '',
            error_details: [],
        }
    },
    methods: {
        async submitForm() {
            this.$store.commit('setIsTopLoading', true)
            if (Number.isInteger(this.autoTime) && this.autoTime > 300) {
                await this.$mainApi.post('api/client/auto-logout-time/', {
                    "auto": this.autoTime
                })
                    .then(response => {
                        if(response.data.status === 80){
                            this.$toast.success(this.$t('common_success'))
                        }else{
                            this.$toast.error(response.data.errors)
                            this.error_details = response.data.details
                        }
                    })
            } else {
                this.$swal.fire({
                    title: 'Must be more than 300s',
                    icon: 'error',
                })
            }
            this.$store.commit('setIsTopLoading', false)
        },
        async getBackend(){
            this.$store.commit('setIsTopLoading', true)
            await this.$mainApi.get('api/client/auto-logout-time/')
                .then(response => {
                    this.autoTime = response.data.details
                })
            this.$store.commit('setIsTopLoading', false)
        },
    },
    mounted(){
        document.title = this.$t('title') + ' | ' + this.$t('auto_logout_timer')
        this.getBackend()
    }
}
</script>

<style scoped>

</style>
